"use strict";exports.DATA_TEST_IDS={INPUT_BOX:"input-box",ICON:"icon",LABEL:"label",CHECK_BOX:"style-check-box",CHECK_BOX_GROUP:"style-check-box-group"};
//# sourceMappingURL=index.js.map
